import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import SearchManager from './SearchManager';

class SearchStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.SEARCH_STORE_SEARCH:
        SearchManager.search(action.query);
        return state;

      case ActionTypes.SEARCH_STORE_SEARCH_COMPLETED:
        return action.results;

      default:
        return state;
    }
  }
}

export default new SearchStore();
